
(function () {
  function initializeBIS(container) {
    const sectionId = container.id.replace('odin-klaviyo-bis-', '');
    const variantsElement = document.getElementById(
      'odin-bis-variants-' + sectionId
    );

    if (!variantsElement) return;

    let variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Odin BIS: Invalid variant data', error);
      return;
    }

    const productForm = document.getElementById('product-form-' + sectionId);
    const bisForm = container.querySelector('.odin-klaviyo-bis__form');
    const message = container.querySelector('.odin-klaviyo-bis__message');

    if (!productForm || !bisForm) return;

    function updateBIS() {
      const variantInput = productForm.querySelector('[name="id"]');
      const variantId = variantInput ? variantInput.value : null;
      const variant = variants.find(v => String(v.id) === String(variantId));

      container.hidden = !variant || variant.available;
      container.dataset.variantId = variant ? variant.id : '';
      message.textContent = '';
      container.classList.remove('odin-klaviyo-bis--success');
    }

    // Watch for variant changes made by the Symmetry theme.
    const observer = new MutationObserver(updateBIS);
    observer.observe(productForm, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });

    productForm.addEventListener('change', () => {
      requestAnimationFrame(updateBIS);
    });

    
bisForm.addEventListener('submit', async function (event) {
  event.preventDefault();

  updateBIS();

  const variantId = container.dataset.variantId;
  const variant = variants.find(
    v => String(v.id) === String(variantId)
  );

  const emailInput = bisForm.querySelector('input[name="email"]');
  const button = bisForm.querySelector('button[type="submit"]');
  const email = emailInput.value.trim();

  if (!variant || variant.available) {
    message.textContent = 'Please select a sold-out size.';
    return;
  }

  if (!emailInput.checkValidity()) {
    emailInput.reportValidity();
    return;
  }

  const payload = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email
            }
          }
        },
        channels: ['EMAIL']
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: '$shopify:::$default:::' + variant.id
          }
        }
      }
    }
  };

  button.disabled = true;
  button.textContent = 'Submitting...';
  message.textContent = '';

  try {
    const response = await fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=W4AUJb',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify(payload)
      }
    );

    if (!response.ok) {
      const errorDetails = await response.text();
      console.error('Odin BIS Klaviyo error:', response.status, errorDetails);
      throw new Error('Subscription request failed');
    }

    container.classList.add('odin-klaviyo-bis--success');

message.textContent =
  "✓ YOU'RE ON THE LIST! We'll email you when your size is back in stock.";

bisForm.reset();
  } catch (error) {
    console.error('Odin BIS:', error);
    message.textContent =
      'Something went wrong. Please try again.';
  } finally {
    button.disabled = false;
    button.textContent = 'NOTIFY ME WHEN AVAILABLE';
  }
});

    updateBIS();
  }

  function initializeAll() {
    document.querySelectorAll('.odin-klaviyo-bis').forEach(initializeBIS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
